import actionMapping from '../utils/actionMapping';
import middlewareFactory from './middlewareFactory';

const analyticsMiddleware = middlewareFactory(actionMapping);

export default analyticsMiddleware;
